import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ContactNote from 'src/models/ContactNote';
import moment from 'moment';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';

interface IContactNoteFormProps {
    contactNote: ContactNote;
    saveComplete: boolean;
    selectedOwnershipIds: Array<number>;
    ownerDetail: LeaseGenerationOwnerData;

    onSubmit: (data: ContactNote, event: React.FormEvent<HTMLFormElement>) => void;
    initializeContactNote: () => ContactNote;
}

const ContactNoteForm = (props: IContactNoteFormProps) => {
    const { register, handleSubmit, reset } = useForm();

    useEffect(() => {
        console.log('Contact Note 2: ', props.contactNote);
        initializeData();
    }, [props.ownerDetail]);

    const showSelectedGlobalIds = () => {
        if (props.selectedOwnershipIds.length > 0) {
            return props.selectedOwnershipIds.map((selectedOwnershipId: number, index) => {
                const tempTract = props.ownerDetail?.tracts.find((x) => x.ownershipId === selectedOwnershipId);
                if (tempTract) {
                    const tempGlobalId = `${tempTract.sectionNumber}.${tempTract.tractNumber}-${tempTract.horizonNumber}`;
                    return (
                        <>
                            <span key={index}>{tempGlobalId}</span>
                            {index < props.selectedOwnershipIds.length - 1 ? <span>, </span> : null}
                        </>
                    );
                } else {
                    return <span />;
                }
            });
        } else {
            return <span />;
        }
    };

    const initializeData = () => {
        let formReset = props.initializeContactNote();
        reset(formReset);
    };

    return (
        <div style={{ width: '50%', borderRight: '1px solid grey', margin: '.5rem', paddingRight: '1rem' }}>
            {props.contactNote && (
                <>
                    <form onSubmit={handleSubmit(props.onSubmit)}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>Note</div>
                            <div>
                                <span style={{ marginRight: '1rem' }}>Attached Tracts:</span>
                                {showSelectedGlobalIds()}
                            </div>
                        </div>
                        <textarea
                            name="note"
                            id="note"
                            ref={register}
                            style={{ width: '100%', minHeight: '30rem', border: '0', borderBottom: '1px solid grey' }}
                        />
                        <br />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <input
                                type="submit"
                                value={props.saveComplete ? 'Save Complete!' : 'Save'}
                                style={
                                    props.selectedOwnershipIds?.length > 0
                                        ? { border: '0', backgroundColor: '#6393C1', color: 'white', height: '3rem' }
                                        : { border: '0', backgroundColor: '#bbbbbb', color: 'darkgrey', height: '3rem' }
                                }
                                disabled={!(props.selectedOwnershipIds?.length > 0)}
                            />
                            {props.selectedOwnershipIds?.length === 0 && <div>No Tracts selected</div>}
                            <div>{`Last Modified: ${moment(props.contactNote?.modifiedDate).format('MM/DD/YYYY')}`}</div>
                        </div>
                    </form>
                </>
            )}
            {!props.contactNote && <div>Loading...</div>}
        </div>
    );
};

export default ContactNoteForm;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ContactNoteForm.tsx